/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Image_Subtitles_TitleInputs */

const en_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Subtitles`)
};

const fr_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres en image`)
};

const de_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriften`)
};

const it_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli delle immagini`)
};

const ru_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры к изображениям`)
};

const es_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos de imágenes`)
};

const zh_cn2_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片字幕`)
};

const ja_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像の字幕`)
};

const hi_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छवि उपशीर्षक`)
};

const pt_pt2_file_export_image_subtitles_title = /** @type {(inputs: File_Export_Image_Subtitles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas de imagem`)
};

/**
* | output |
* | --- |
* | "Image Subtitles" |
*
* @param {File_Export_Image_Subtitles_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_image_subtitles_title = /** @type {((inputs?: File_Export_Image_Subtitles_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Image_Subtitles_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_image_subtitles_title(inputs)
	if (locale === "de") return de_file_export_image_subtitles_title(inputs)
	if (locale === "it") return it_file_export_image_subtitles_title(inputs)
	if (locale === "ru") return ru_file_export_image_subtitles_title(inputs)
	if (locale === "es") return es_file_export_image_subtitles_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_image_subtitles_title(inputs)
	if (locale === "ja") return ja_file_export_image_subtitles_title(inputs)
	if (locale === "hi") return hi_file_export_image_subtitles_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_image_subtitles_title(inputs)
	return en_file_export_image_subtitles_title(inputs)
});